import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Api from '../../../libraries/api';
import ErrorHandling from '../../../libraries/error-handling';
import { history } from '../../../shared/configure-store';
import { toBackendOrder } from '../master-case-survey-status/order-display';

require('dotenv').config();
const validator = new SimpleReactValidator({ locale: process.env.REACT_APP_LOCALE });

const API_BASE = '/lifecycle/approval-status-master';
const ROUTE_BASE = '/master-approval-status';

class MasterApprovalStatusAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingButton: false,
            errors: {},
            name: '',
            sort_order: '1',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Add Approval Status';

        const urlParams = queryString.parse(this.props.location?.search || '');
        const no = urlParams.no;

        if (no !== undefined && no !== null && no !== '') {
            const n = Number(no);
            if (Number.isFinite(n) && n >= 1) {
                this.setState({ sort_order: String(Math.floor(n)) });
            }
        }
    }

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            validator.showMessages();
            this.forceUpdate();
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        const params = {
            name: this.state.name,
            sort_order: toBackendOrder(this.state.sort_order),
        };

        Api.post(API_BASE, params, false)
            .then(() => {
                this.setState({ loadingButton: false });
                history.push(ROUTE_BASE);
                this.showMessage(true, 'Approval status added');
            })
            .catch((err) => {
                if (ErrorHandling.checkErrorTokenExpired(err)) {
                    this.setState({ loadingButton: false });
                } else {
                    this.setState({ errors: err.errors || {}, loadingButton: false });
                    this.showMessage(false, 'Invalid format data');
                }
            });
    };

    handleGo = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Create Approval Status</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to={ROUTE_BASE}>Approval Status</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Create
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <form name="add" id="addApprovalStatus" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Name</label>
                                    <TextField
                                        variant="outlined"
                                        type="text"
                                        id="name"
                                        name="name"
                                        label="Name"
                                        onChange={(e) => this.handleChange(e, 'name')}
                                        value={this.state.name}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className="text-danger">{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>No.</label>
                                    <TextField
                                        variant="outlined"
                                        type="number"
                                        id="sort_order"
                                        name="sort_order"
                                        label="No."
                                        onChange={(e) => this.handleChange(e, 'sort_order')}
                                        value={this.state.sort_order}
                                        autoComplete="off"
                                        fullWidth
                                        inputProps={{ min: 1 }}
                                    />
                                    {validator.message('sort_order', this.state.sort_order, 'required|numeric|min:1,num')}
                                    <div className="text-danger">{this.state.errors.sort_order}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button
                                    variant="contained"
                                    className="mr-3"
                                    onClick={() => this.handleGo(ROUTE_BASE)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton && 'disabled'}
                                >
                                    Submit
                                    {this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default MasterApprovalStatusAdd;
